import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import { IconPluginsOptions } from './types';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';
import { DEFAULT_ICONS } from './defaults';

const IconElement = withDynamicBlogEditorPluginHydration()(dynamicEditorComponent(() => import('./component/IconElement'), {
  loading: ({ props }) => <span {...props?.attributes}>{props?.children}</span>,
}));

const size = '1.6em';

export const renderIconElement =
  (options: IconPluginsOptions) =>
    ({ element, children, attributes }: RenderElementProps) => {
      if (element.type === 'ICON' && element.iconKey) {
        const iconId = element.iconKey;
        const icon = DEFAULT_ICONS.find((i) => i.key === iconId);
        if (icon) {
          return (
          <IconElement icon={icon} size={size} element={element} attributes={attributes}>
            {children}
          </IconElement>
          );
        }
      }
      return null;
    };
